export default __webpack_public_path__ + "static/media/6.e9d7d5c1.jpg";